import { Grid, makeStyles } from '@material-ui/core';
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useFormState, useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import {
  changeToSubConsultMode,
  success,
} from '../../../features/declaracao-importacao/declaracaoImportacaoSlice';

import {
  fetchTributosTtceByNcmPais,
} from '../../../features/ncm-subitem/ncmSubitemAPI';

import { setErrorFeedback, setSuccessFeedback } from '../../../features/feedback/feedbackSlice';

import { doGetQCXRequest, doPostQCXRequest, doPutQCXRequest } from '../../../utils/api/domain/domain-api-utils';



import QCXAtributosTratamentoTributarioDuimp from '../../../shared-components/atributos-tratamento-tributario-duimp/QCXAtributosTratamentoTributarioDuimp';
import QCXAtributosFundamentoLegalDuimpFormGroup from '../../../shared-components/atributos-fundamento-legal-duimp-form-group/QCXAtributosFundamentoLegalDuimpFormGroup';

import QCXFormSubtitle from '../../form-title/QCXFormSubtitle';
import QCXFormTitle    from '../../form-title/QCXFormTitle';

export default function TributosMercadoriaDuimp({
  disabled,
}) {

  const form = useForm();
  const dispatch = useDispatch();

  const { values } = useFormState();
  const [adicaoResumida, setAdicaoResumida] = useState({});
  const [ultimoIdConsultado, setUltimoIdConsultado] = useState(null);

  const fetchAdicaoResumida = useCallback(async () => {
    const id = values?.adicaoId;

    if (!id) return;
    if (id === ultimoIdConsultado) return;

    setUltimoIdConsultado(id);

    try {
      const response = await doGetQCXRequest(['diduimp', 'adicao-basic', id]);

      setAdicaoResumida(response.data);
      dispatch(changeToSubConsultMode());
      dispatch(success());
    } catch (error) {
      console.log('deu erro')
      console.log(error)
      dispatch(
        setErrorFeedback({
          message: 'Erro ao buscar valores de metadados da adição.',
        })
      );
    }

  }, [values]);

  useEffect(() => {
    fetchAdicaoResumida();
  }, [values])





  const modes = useMemo(() => ({
    isConsult: disabled,
  }), [disabled])

  return (
    <>

      <>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <QCXFormTitle title={'Atributos de Fundamento Legal DUIMP'.toUpperCase()} />
        </Grid>
        <QCXAtributosFundamentoLegalDuimpFormGroup
          modes={modes}
          adicao={adicaoResumida}
          itemStep
        />
      </>

    </>
  )
}
